import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent extends HistoryBaseComponent implements OnInit {

  public mail : string = "office@shareme.co";
  public tel : string = "+359 898 983 228";
  public QOexpanded = false;
  public QAExpanded = false;

  constructor(
    protected location: Location,
    protected historyService: HistoryService

  ) { 
    super(location, historyService);
    this._pageTitle = 'contacts'
   }

  ngOnInit(): void {
  }

  arrowStyle(toRotate: boolean) {
    if (toRotate) return 'right: 15px; float: right; top: 3px; position: relative; transform: rotate(90deg);';
    return 'right: 15px; float: right;  top: 6px; position: relative;';
  }

  openEmail() {
    window.open("mailto:" + this.mail, '_blank');
  }

  openTel() {
    window.open("tel:" + this.tel, '_blank');
  }

}
